module.exports = __webpack_public_path__ + "static/media/andriod_QRcode.e9905dc5.png";